import { render, staticRenderFns } from "./LeaveCalendar.vue?vue&type=template&id=473d8589&scoped=true"
import script from "./LeaveCalendar.vue?vue&type=script&lang=js"
export * from "./LeaveCalendar.vue?vue&type=script&lang=js"
import style0 from "./LeaveCalendar.vue?vue&type=style&index=0&id=473d8589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d8589",
  null
  
)

export default component.exports